import {Column, Entity, PrimaryGeneratedColumn} from "typeorm"
import { bigint } from "../../transofrmers/BigInt";

@Entity({name: "tele2_usage"})
export class Tele2Usage {

	@PrimaryGeneratedColumn()
	id!: number;

	@Column()
	iccid!: string;
	
	@Column()
	msisdn!: string;
	
	@Column('datetime')
	timestamp!: Date;

	@Column({ type: "bigint", transformer:bigint })
	ctd_data_usage!: number;

	@Column({ type: "bigint", transformer:bigint })
	ctd_sms_usage!: number;

	@Column({ type: "bigint", transformer:bigint })
	ctd_voice_usage!: number;

	@Column()
	session_count!: number;
}